/**
 * Signalement de l'état de l'application famille (#2542).
 *
 * Partagé par parent-pwa.js et parent-push.js : ce que le parent écarte et
 * l'installation de la PWA sont enregistrés côté serveur, qui décide ensuite
 * où afficher les bandeaux et fournit les statistiques d'installation.
 */

export function meta(name) {
    const tag = document.querySelector(`meta[name="${name}"]`);

    return tag ? tag.getAttribute('content') : null;
}

/**
 * Signale un événement au serveur. Sans attente ni conséquence visible : le
 * masquage se fait tout de suite côté client, l'enregistrement ne fait que le
 * rendre durable.
 *
 * @param {'install_banner_dismissed'|'push_banner_dismissed'|'pwa_installed'} event
 */
export function reportAppState(event) {
    const url = meta('app-state-url');

    if (!url) {
        return Promise.resolve();
    }

    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'X-CSRF-TOKEN': meta('csrf-token'),
        },
        credentials: 'same-origin',
        body: JSON.stringify({ event }),
    }).catch(() => {
        // Le bandeau reviendra en haut au prochain chargement : sans gravité.
    });
}
